import "../styles/TituloModulo.css";
import { useGlobal } from "../context/ContenedorGlobal";

function TituloModulo() {

    const { moduloActual, identidad } = useGlobal();

    // Si no hay móduloActual, usamos la categoría del usuario 
    const nombre = moduloActual || identidad?.categoria || "Página Principal";

    return (
        <h2 className="titulo-modulo">
            Modulo: {nombre}
        </h2>
    );
}

export default TituloModulo;